module.exports = __webpack_public_path__ + "static/media/background_curve-out-up-dark.5a31996a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background_curve-out-up-dark.svg
// module id = 222
// module chunks = 0